module.exports = __webpack_public_path__ + "static/media/user-icon.84f6cb66.png";